import request from '../utils/request';
import noAuthRequest from '../utils/noAuthRequest';
import {
    CompleteUserProfilePayload,
    GoogleAuthResponse,
    RegisterPayload,
} from '../utils/types';

export async function login(email: string, password: string) {
    await noAuthRequest.post('/auth/login', { email, password });
}

export async function register(payload: RegisterPayload) {
    await noAuthRequest.post('/auth/register', payload);
}

export async function checkUsername(username: string) {
    await noAuthRequest.post('/auth/username/check', { username });
}

export async function googleAuth(token: string) {
    const response = await noAuthRequest.post<GoogleAuthResponse>(
        '/auth/google',
        { token }
    );

    return response.data;
}

export async function completeUserProfile(payload: CompleteUserProfilePayload) {
    await request.post('/auth/google/complete', payload);
}

export async function confirmEmail(email: string, emailCode: string) {
    await noAuthRequest.post('/auth/confirm-email', { email, emailCode });
}

export async function getConfirmEmailCode(email: string) {
    await noAuthRequest.post('/auth/confirm-email/code', { email });
}

export async function authenticate(email: string, emailToken: string) {
    const response = await request.post('/auth/authenticate', {
        email,
        emailToken,
    });

    return response.data;
}

export async function getResetPasswordToken(email: string) {
    await noAuthRequest.post('/auth/reset-password/code', { email });
}

export async function resetPassword(
    email: string,
    emailCode: string,
    password: string
) {
    await noAuthRequest.post('/auth/reset-password', {
        email,
        emailCode,
        password,
    });
}

export async function logout() {
    await request.post('/auth/logout');
}

export async function uploadImage(image: File) {
    const formData = new FormData();
    formData.append('file', image);

    const response = await request.post('/auth/image/upload', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });

    return response.data;
}
